<section class="section-container">
  <div class="section-content">
    <div *ngIf="isCasasBahia">
      <div class="contacts-container">
        <h4>Ficou com dúvidas sobre
          o carnê?</h4>
        <div class="contact-info">
          <p class="title">Central de atendimento</p>
          <p class="description">0800 025 8880</p>
        </div>
        <div class="contact-info">
          <p class="title">Horário de funcionamento</p>
          <p class="description">Segunda a sábado das 7h às 21h50</p>
        </div>
      </div>

      <hr>

      <div class="contacts-container">
        <h4>Ficou com dúvidas sobre 
          o cartão?</h4>
        <div class="contact-info">
          <p class="description">Para dúvidas sobre a negociação
            do cartão Casas Bahia, entre em 
            contato com os atendimentos do 
            Bradesco <a href="https://banco.bradesco/html/classic/atendimento/fale-conosco/centrais-de-atendimento.shtm#conteudo-ancora" target="_blank">clicando aqui</a>.
          </p>
        </div>
      </div>
    </div>

    <div *ngIf="!isCasasBahia" class="contacts-container">
      <h4>Ficou com dúvidas?</h4>
      <div class="contact-info">
        <p class="title">Central de atendimento</p>
        <p class="description hide-on-cb">0800 022 1400</p>
        <p class="description hide-on-pf">0800 025 8880</p>
      </div>
      <div class="contact-info">
        <p class="title">Horário de funcionamento</p>
        <p class="description">Segunda a sábado das 7h às 21h50</p>
      </div>
    </div>

    <div class="faq-container">
      <h4 *ngIf="!isCasasBahia">Ficou com dúvidas?</h4>
      <ul *ngIf="!isCasasBahia" class="expansion-faq-list">
        <li *ngFor="let faq of faqListPF">
          <button (click)="handleExpandPanel(faq.id)">
            {{faq.question}}

            <div class="icon-container" [class.expand]="faq.expanded">
              <mat-icon class="icon">expand_more</mat-icon>
            </div>
          </button>
          <div class="answer-container" [class.expand-li]="faq.expanded">
            {{faq.answer}}
          </div>
        </li>
      </ul>

      <ul *ngIf="isCasasBahia" class="expansion-faq-list">
        <li *ngFor="let faq of faqListCB">
          <button (click)="handleExpandPanel(faq.id)">
            {{faq.question}}

            <div class="icon-container" [class.expand]="faq.expanded">
              <mat-icon class="icon">expand_more</mat-icon>
            </div>
          </button>
          <div class="answer-container" [class.expand-li]="faq.expanded">
            <strong>Carnê</strong>
            <span>{{faq.secondCopyAnswer}}</span>
          </div>
          <div class="answer-container" [class.expand-li]="faq.expanded">
            <strong>Cartão</strong>
            <span [innerHTML]="faq.creditCardAnswer" ></span>
          </div>
        </li>
      </ul>
    </div>

  </div>

  <div class="footer">
    <hr>
    <p>
      <strong> Grupo Casas Bahia S.A. </strong>
      Av. Rebouças, 3970, A28, São Paulo - SP, 05420-918, CNPJ 33.041.260/0652-90, Inscrição
      Estadual 133.091.229.115
    </p>
  </div>
</section>